import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'
import type { Middleware } from 'openapi-fetch'
import type { paths } from './client' // generated by openapi-typescript

export const BACKEND_URL = import.meta.env.DEV
  ? 'http://localhost:8765'
  : 'https://api.oumma.app'

let sessionToken: string | null = null

// TODO: fix the client propagatation
export const $client = createFetchClient<paths>({
  baseUrl: BACKEND_URL,
})

// TODO update
const UNPROTECTED_ROUTES = ['/v1/login', '/v1/logout', '/v1/public/']
const authMiddleware: Middleware = {
  onRequest({ request, schemaPath }) {
    if (UNPROTECTED_ROUTES.some((pathname) => schemaPath === pathname)) {
      // Don't modify the request for unprotected paths.
      return undefined
    }

    if (sessionToken != null) {
      request.headers.set('Authorization', `Bearer ${sessionToken}`)
    }
    return request
  },
}

$client.use(authMiddleware)

export function setSessionToken(newToken: string | null) {
  sessionToken = newToken
}

export const $api = createClient($client)
